import React from 'react';
import './footer.scss';

class Footer extends React.Component {
    render() {
        var currDate = new Date();
        var currYear = currDate.getFullYear();

        return (
            <footer id="footer" className="container-fluid">
                <div className="footer-container">
                    <div className="footer-content">
                        <div className="footer-logos-container">
                            <div>
                                <a href="https://www.healthonnet.org/HONcode/Conduct.html?HONConduct694855" 
                                    rel="noopener noreferrer" target="_blank">
                                    <img 
                                        alt="This website is certified by Health On the Net Foundation. Click to verify." 
                                        src="https://www.honcode.ch/HONcode/Seal/HONConduct694855_s.gif" 
                                    />
                                </a>
                            </div>
                        </div>

                        <p>
                            Copyright © 2005 - {currYear} Healthline Media is a Red Ventures Company. All rights reserved. 
                            Our content does not constitute a medical consultation. See a certified medical professional for diagnosis. 
                            <a href="https://www.healthline.com/health/privacy-policy?ref=marketplace" target="_blank"> Privacy Policy</a>.
                        </p>
                    </div>
                </div>
            </footer>
        )
    }
}

export default Footer;